export default "__VITE_ASSET__DM47sG$x__"